import {
  CREATE_TRIGGER_FAIL,
  CREATE_TRIGGER_START,
  CREATE_TRIGGER_SUCCESS,
  CREATE_HISTORY_SUCCESS,
  CREATE_HISTORY_START,
  CREATE_HISTORY_FAIL,
  TRIGGERS_DETAIL_SUCCESS,
  TRIGGERS_DETAIL_START,
  TRIGGERS_DETAIL_FAIL,
  TRIGGERS_SLUG_SUCCESS,
  TRIGGERS_SLUG_FAIL,
  TRIGGERS_SLUG_START,
  HISTORY_DETAIL_SUCCESS,
  HISTORY_DETAIL_START,
  HISTORY_DETAIL_FAIL
} from './constants';
import {
  requestGetTriggersWithSlug,
  requestGetHistory,
  requestGetTriggers,
  requestCreateTrigger,
  requestCreateHistory
} from '../../api/logging';

export const createTriggerStart = () => ({ type: CREATE_TRIGGER_START });
export const createTriggerSuccess = (data) => ({ type: CREATE_TRIGGER_SUCCESS, payload: data });
export const createTriggerFail = (message) => ({ type: CREATE_TRIGGER_FAIL, payload: message });

export const createHistoryStart = () => ({ type: CREATE_HISTORY_START });
export const createHistorySuccess = (data) => ({ type: CREATE_HISTORY_SUCCESS, payload: data });
export const createHistoryFail = (message) => ({ type: CREATE_HISTORY_FAIL, payload: message });

export const getHistoryStart = () => ({ type: HISTORY_DETAIL_START });
export const getHistorySuccess = (data) => ({ type: HISTORY_DETAIL_SUCCESS, payload: data });
export const getHistoryFail = (message) => ({ type: HISTORY_DETAIL_FAIL, payload: message });

export const getTriggersStart = () => ({ type: TRIGGERS_DETAIL_START });
export const getTriggersSuccess = (data) => ({ type: TRIGGERS_DETAIL_SUCCESS, payload: data });
export const getTriggersFail = (message) => ({ type: TRIGGERS_DETAIL_FAIL, payload: message });

export const getTriggersSlugStart = () => ({ type: TRIGGERS_SLUG_START });
export const getTriggersSlugSuccess = (data) => ({ type: TRIGGERS_SLUG_SUCCESS, payload: data });
export const getTriggersSlugFail = (message) => ({ type: TRIGGERS_SLUG_FAIL, payload: message });

export const getHistory = (payload) => async (dispatch) => {
  try {
    dispatch(getHistoryStart());
    const data = await requestGetHistory(payload);
    dispatch(getHistorySuccess(data));
  } catch (error) {
    dispatch(getHistoryFail(error.detail));
  }
};

export const createHistory = (data) => async (dispatch) => {
  try {
    dispatch(createHistoryStart());
    const res = await requestCreateHistory(data);
    dispatch(createHistorySuccess(res));
  } catch (error) {
    dispatch(createHistoryFail(error.detail));
  }
};

export const getTriggers = () => async (dispatch) => {
  try {
    dispatch(getTriggersStart());
    const { data } = await requestGetTriggers();
    dispatch(getTriggersSuccess(data));
  } catch (error) {
    dispatch(getTriggersFail(error.detail));
  }
};

export const getTriggersSlug = (slug) => async (dispatch) => {
  try {
    dispatch(getTriggersSlugStart());
    const data = await requestGetTriggersWithSlug(slug);
    dispatch(getTriggersSlugSuccess(data));
  } catch (error) {
    dispatch(getTriggersSlugFail(error.detail));
  }
};

export const createTrigger = (data) => async (dispatch) => {
  try {
    dispatch(createTriggerStart());
    const res = await requestCreateTrigger(data);
    dispatch(createTriggerSuccess(res));
  } catch (error) {
    dispatch(createTriggerFail(error.detail));
  }
};
